module.exports = __webpack_public_path__ + "img/male.6dcedb42.jpg";